export default {
  TOKEN_EXECUTE_REQUEST: 'TOKEN_EXECUTE_REQUEST',
  TOKEN_EXECUTE_SUCCESS: 'TOKEN_EXECUTE_SUCCESS',
  TOKEN_EXECUTE_FAILURE: 'TOKEN_EXECUTE_FAILURE',
};
